import {
    Stack,
    Pivot,
    PivotItem,
    IconButton,
    IIconProps,
    FontWeights,
} from '@fluentui/react';
import React, { useContext } from 'react';
import { UserProfile } from '../../UserPages/UserProfile';
import { routeKeys } from '../../../../Common/util/RouteUtils';
import { PageBrand } from '../PageBrand';
import { useHistory, useLocation } from 'react-router-dom';
import { ThemeContext } from '../../../models/ThemeContext';
import { getThemeFromString } from '../../../../Common/util/localStorageUtils';
import { sanitizeRedirectUrl } from '../../../../Common/util/urlValidation';

interface IMobileSitHeaderProps {
    openNav: () => void;
}

export const MobileSiteHeader: React.FC<IMobileSitHeaderProps> = (
    props: IMobileSitHeaderProps
) => {
    const themeContext = useContext(ThemeContext);
    const theme = getThemeFromString(themeContext.themeName);

    const history = useHistory();
    const location = useLocation();

    const mailIcon: IIconProps = {
        iconName: 'NewMail',
        styles: { root: { fontWeight: FontWeights.bold } },
    };

    let homeItem = (
        <PivotItem
            headerText="Sovereign Release Manager"
            itemKey={routeKeys.Home}
            onRenderItemLink={() => {
                return <PageBrand />;
            }}
        />
    );

    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'space-between',
            }}
        >
            <div
                style={{
                    marginRight: 'auto',
                }}
            >
                <Stack
                    horizontal
                    style={{
                        alignItems: 'center',
                    }}
                >
                    <IconButton
                        style={{
                            color: theme.palette.neutralPrimary,
                        }}
                        iconProps={{
                            iconName: 'GlobalNavButton',
                        }}
                        onClick={() => {
                            props.openNav();
                        }}
                        ariaLabel="Open navigation menu"
                        title="Navigation"
                    />
                    <Pivot
                        headersOnly={true}
                        selectedKey={null}
                        onLinkClick={(
                            item?: PivotItem,
                            ev?:
                                | React.MouseEvent<HTMLElement, MouseEvent>
                                | React.KeyboardEvent<HTMLElement>
                        ) => {
                            const itemKey = item
                                ? item.props.itemKey || ''
                                : '';
                            // Validate the redirect URL to prevent unvalidated redirects (SM01507)
                            const safePath = sanitizeRedirectUrl(
                                itemKey,
                                routeKeys.Home
                            );
                            if (location.pathname !== safePath) {
                                history.push(safePath);
                            }
                        }}
                    >
                        {homeItem}
                    </Pivot>
                </Stack>
            </div>

            <div
                style={{
                    margin: '2px 3px 0 2px',
                    paddingTop: '5px',
                }}
            >
                <IconButton
                    iconProps={{ iconName: 'StatusCircleQuestionMark' }}
                    title="Documentation"
                    href={process.env.REACT_APP_SRM_DOCS_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    ariaLabel="Documentation (opens in new tab)"
                />
            </div>

            <div
                style={{
                    marginTop: '2px',
                    marginRight: '5px',
                }}
            >
                <UserProfile />
            </div>
        </div>
    );
};
